<template>
  <Plain title="About">
    <div slot="page_body">
      [text goes here!]
    </div>
  </Plain>
</template>
<script>
import Plain from './plain'

export default {
  name: 'About',
  components: {
    Plain
  }
}
</script>



// WEBPACK FOOTER //
// src/components/about.vue